import _ from "lodash";

export default function removeFromSet<T>(set: Array<T>, value: T): Array<T> {
    return _.reject(set, v => _.isEqual(v, value));
}
